import { Link } from 'react-router'

import { BookIcon, LinkIcon, MailIcon } from 'app/common/presentation/icons'

import styles from './Link.module.scss'

interface LinkComponentProps {
  title: string
  to: string | (() => void)
  type?: 'mail' | 'website'
}

const LinkComponent = ({ title, to, type = 'website' }: LinkComponentProps) => (
  <div className={styles.link}>
    {typeof to === 'string' && to.includes('docs.innkeepr.ai') && <BookIcon />}
    {type === 'mail' && <MailIcon />}
    <div>
      {typeof to === 'string' ? (
        type === 'mail' ? (
          <Link to={`mailto:${to}`}>{title}</Link>
        ) : (
          <Link rel="noopener noreferrer" target="_blank" to={to}>
            {title}
          </Link>
        )
      ) : (
        <a onClick={to}>{title}</a>
      )}

      {type === 'website' && <LinkIcon />}
    </div>
  </div>
)

export default LinkComponent
